import { clsxm } from '@bridge/ui';
import Image from 'next/image';

interface BridgeWordmarkProps {
  className?: string;
  decorative?: boolean;
  tone?: 'adaptive' | 'inverse';
}

const WORDMARK_DIMENSIONS = {
  height: 24,
  width: 63,
} as const;

export default function BridgeWordmark({ className, decorative = false, tone = 'adaptive' }: BridgeWordmarkProps) {
  const accessibilityProps = decorative ? { 'aria-hidden': true } : { 'aria-label': 'Bridge', role: 'img' };

  return (
    <span {...accessibilityProps} className={clsxm('inline-flex', className)}>
      <span className="inline-flex h-6 w-[63px] shrink-0" aria-hidden>
        {tone === 'adaptive' && (
          <Image
            className="block dark:hidden"
            alt=""
            height={WORDMARK_DIMENSIONS.height}
            src="/brand/bridge-wordmark-dark.svg"
            width={WORDMARK_DIMENSIONS.width}
          />
        )}
        <Image
          className={clsxm('hidden dark:block', tone === 'inverse' && 'block!')}
          alt=""
          height={WORDMARK_DIMENSIONS.height}
          src="/brand/bridge-wordmark-light.svg"
          width={WORDMARK_DIMENSIONS.width}
        />
      </span>
    </span>
  );
}

export { WORDMARK_DIMENSIONS };
export type { BridgeWordmarkProps };
